import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function Card({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={cn(
        'rounded-md border border-border bg-surface-card p-6 shadow-[0_1px_3px_rgba(13,27,61,0.10)]',
        className,
      )}
    >
      {children}
    </div>
  );
}
